<template>
  <div class="no-results-list">
    <div class="align-center-div">{{ textContent }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["text"],
  computed: {
    textContent() {
      if (!this.text || this.text == "" || this.text.length == 0)
        return this.$t("general.doSearchNew");
      return " " + this.$t("general.noResults");
    },
  },
};
</script>

<style lang="scss" scoped>
.no-results-list {
  color: var(--text-color1);
  height: calc(100% - 65px);
  text-align: center;
  position: relative;
}
</style>
